import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import Tooltip from "@material-ui/core/Tooltip";
import SearchIcon from "@material-ui/icons/Search";
import previewIcon from "Assets/newicons/user-interface/eye-show/outline/eye-show-outline-16px.svg";
import classNames from "classnames";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import Drawer from "@material-ui/core/Drawer";
import DrawerHeader from "Component/Headers/drawerHeader";

import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { instance } from "../../../Actions/AxiosInstance";
import { RightDrawer } from "../../../Actions/commonAction";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import { updateSubscriptionInfo } from "../../../Actions/SubscriptionInfo";
import defaultEmp from "../../../Assets/Images/defaultEmp.svg";
import "../../../Assets/SCSS/components/ReportRobo.scss";
import createstore from "../../../store";
import { getFormattedDate, getFormattedImageLink } from "../../../Utils";
import "./index.style.css";
import moment from "moment";

const styles = (theme) => ({
  searchIcon: {
    width: theme.spacing.unit * 9,
    height: "100%",
    position: "absolute",
    // pointerEvents: 'none',
    display: "flex",
    alignItems: "left",
    justifyContent: "left",
    paddingLeft: 10,
    paddingTop: 10,
  },
});

class ScheduledReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 10,
      offset: 0,
      fullcount: 0,
      page: 0,
      isView: false,
      selectedReport: null,
      reportList: [],
      search: "",
      actionidList: "",
      message: "",
      permissions: { readOnly: false, editable: false },
    };
    this.onBeforeUpload = this.onBeforeUpload.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    window.scrollTo(0, 0);
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.getReports();
  }

  componentWillMount() {
    const { SubscriptionInfo } = createstore.getState();
    const DateFormat = get(
      SubscriptionInfo,
      "SubscriptionData.dateformatname",
      "",
    );
    let ShortDateFormat = DateFormat.split(" ");
    ShortDateFormat = ShortDateFormat[0];
    this.setState({ ShortDateFormat });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
    window.removeEventListener("scroll", this.handleScroll);
  }

  viewReportDetails(report) {
    this.setState({ selectedReport: report, isView: true });
  }

  handleScroll() {
    const windowHeight =
      "innerHeight" in window
        ? window.innerHeight
        : document.documentElement.offsetHeight;
    const { body } = document;
    const html = document.documentElement;
    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight,
    );
    const windowBottom = windowHeight + window.pageYOffset;
    if (windowBottom >= docHeight) {
      this.setState(
        {
          offset: this.state.offset + 10,
        },
        () => this.getReports(),
      );
    } else {
      this.setState({
        message: "no data",
      });
    }
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  getReports() {
    instance
      .get(`reportrobo/schedulereport/${this.state.offset}/${this.state.limit}`)
      .then(
        (result) => {
          let reportList = [];
          const fullcount = result.data.result[0]
            ? result.data.result[0].fullcount
            : 0;
          result.data.result.length > 0
            ? (reportList = [...this.state.reportList, ...result.data.result])
            : (reportList = this.state.reportList);

          this.setState({
            fullcount,
            reportList,
          });
        },
        (error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        },
      );
  }

  handleChangePage = (event, page) => {
    this.setState({ page, offset: this.state.limit * page }, () => {
      this.getReports();
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        limit: event.target.value,
        offset: event.target.value * this.state.page,
      },
      () => {
        this.getReports();
      },
    );
  };

  HelperSliderFlag(flag, report) {
    // this.setState({ HelperSlider: flag })
    let OpenFlag = "";
    if (flag == true) {
      OpenFlag = true;
      this.setState({ OpenFlag });
    } else {
      OpenFlag = false;
      this.setState({ OpenFlag });
    }
    this.props.RightDrawer({
      drawerdata: "ScheduledUserReport",
      open: "right",
      side: flag,
      rptid: report.reportroboid,
    });
  }

  getCountManager = (count) => {
    if (count >= 3) {
      return count - 3;
    }
    return 0;
  };

  searchOnChange(event) {
    this.setState({ search: event.target.value });
  }

  confirmDelete(id) {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          color="inherit"
          size="small"
          onClick={() => this.deleteReport(id)}
        >
          Yes
        </Button>,
        <Button color="inherit" size="small" onClick={() => this.props.closeSnackbar()} >
          No
        </Button>,
      ],
    });
  }

  deleteReport(id) {
    console.log("id", id);
    instance.delete(`reportrobo/deletereport/${id}`).then(
      () => {
        this.props.enqueueSnackbar("Scheduled Report has been Deleted", {
          variant: "success",
        });
        this.setState({ offset: 0, reportList: [] }, () => {
          this.getReports();
        });
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  render() {
    const filteredReport = this.state.reportList.filter((agent) => {
      if (!agent.reportname) {
        return false;
      }
      return (
        agent.reportname
          .toLowerCase()
          .indexOf(this.state.search.toLowerCase()) != -1
      );
    });

    const { classes } = this.props;
    const { selectedReport } = this.state;
    const language = this.props.Language.reportrobo;
    return (
      <IntlProvider locale="en" messages={language}>
        <div>
          <Grid container style={{ marginBottom: 20 }}>
            <Grid item xs={12} md={9} sm={6}>
              <div className="inner-wrapper opaque">
                <div className="form-group">
                  <p className="center">
                    <FormattedMessage
                      id="LbShowing"
                      defaultMessage="Showing "
                    />{" "}
                    {filteredReport.length} of {this.state.fullcount} Reports
                  </p>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={3} sm={6} className="right">
              <div style={{ marginRight: 20 }}>
                <FormControl
                  className={`${classes.searchIcon} searchBox`}
                  style={{
                    height: 38,
                    width: 230,
                    paddingTop: 0,
                    borderRadius: 5,
                    border: "1px solid #d8d8d8",
                  }}
                >
                  <Input
                    placeholder="Search"
                    style={{ height: 35 }}
                    disableUnderline
                    value={this.state.search}
                    fullWidth
                    onChange={this.searchOnChange.bind(this)}
                    startAdornment={
                      <InputAdornment position="start">
                        <SearchIcon color="disabled" />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </div>
              {/* <div className="">
                                <div style={{ width: '100%' }}>
                                    <div className={classes.searchIcon}>
                                        <SearchIcon />
                                    </div>
                                    <Input placeholder="Search" disableUnderline fullWidth className="searchBox"
                                        value={this.state.search}
                                        onChange={this.searchOnChange.bind(this)}
                                    />
                                </div>
                            </div> */}
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} md={12} sm={12} className="">
              <Table className="table-reportrobo">
                <thead>
                  <tr>
                    <th>
                      <FormattedMessage
                        id="LbReportName"
                        defaultMessage="Report Name"
                      />
                    </th>
                    <th>
                      <FormattedMessage
                        id="LbRecipients"
                        defaultMessage="Recipients"
                      />
                    </th>
                    <th>
                      <FormattedMessage
                        id="LbScheduledTime"
                        defaultMessage="Scheduled Time"
                      />
                    </th>
                    {this.props.permissions.editable ? (
                      <th>
                        <span>View</span>
                      </th>
                    ) : (
                      ""
                    )}
                    {this.props.permissions.editable ? (
                      <th>
                        <FormattedMessage
                          id="LbDiscard"
                          defaultMessage="Discard"
                        />
                      </th>
                    ) : (
                      ""
                    )}
                  </tr>
                </thead>
                <tbody>
                  {filteredReport.length > 0 ? (
                    filteredReport.map((report) => (
                      <tr>
                        <td>
                          <span className="normal-dark">
                            {report.reportname}
                          </span>
                          <p className="small-dark-secondary">
                            {getFormattedDate(
                              report.updateddate,
                              this.state.ShortDateFormat,
                            )}{" "}
                          </p>
                        </td>
                        <td>
                          <div style={{ display: "inline-flex" }}>
                            {report.assignedEmployeeList.length > 0 ? (
                              report.assignedEmployeeList.map((mgr) => (
                                <Tooltip
                                  title={mgr.employeename}
                                  placement="top"
                                >
                                  <Link
                                    to={`./profile/${mgr.employeeid}`}
                                    target="_blank"
                                  >
                                    <div className="inlineClass">
                                      {mgr.imagepath == null ? (
                                        <img
                                          src={defaultEmp}
                                          height="56"
                                          className="team-img1"
                                        />
                                      ) : (
                                        <img
                                          src={getFormattedImageLink(
                                            mgr.imagepath,
                                          )}
                                          height="56"
                                          className="team-img1"
                                        />
                                      )}
                                    </div>
                                  </Link>
                                </Tooltip>
                              ))
                            ) : (
                              <div className={classNames("manager")}>
                                No Recipients Added
                              </div>
                            )}
                            {report.assignedEmployeeList.length > 0 ? (
                              this.getCountManager(
                                report.assignedEmployeeList[0].fullcount,
                              ) > 0 ? (
                                <div
                                  className={classNames(
                                    "managerdrawer2",
                                    "cursour-pointer",
                                  )}
                                  onClick={this.HelperSliderFlag.bind(
                                    this,
                                    true,
                                    report,
                                  )}
                                >
                                  +
                                  {this.getCountManager(
                                    report.assignedEmployeeList[0].fullcount,
                                  )}
                                </div>
                              ) : (
                                ""
                              )
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                        <td>{report.frequency}</td>
                        {this.props.permissions.editable ? (
                          <td className="position-rel">
                            {/* <svg
                              className="cursour-pointer report-robo-edit"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              onClick={() =>
                                this.props.handleChange(
                                  null,
                                  0,
                                  report.reportroboid,
                                )
                              }
                            >
                              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z"></path>
                            </svg> */}
                            <img
                              src={previewIcon}
                              onClick={() => this.viewReportDetails(report)}
                              className="cursor-pointer"
                            ></img>
                          </td>
                        ) : (
                          ""
                        )}
                        {this.props.permissions.editable ? (
                          <td>
                            <svg
                              className="cursour-pointer report-robo-edit"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              onClick={() =>
                                this.confirmDelete(report.reportroboid)
                              }
                            >
                              <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z" />
                            </svg>

                            {/* <img src={DeleteIcon} align='center' height='24' width='24'  alt="delete"></img> */}
                          </td>
                        ) : (
                          ""
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="noData no-data">
                        No Record Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Grid>
          </Grid>
          <Drawer
            anchor="right"
            open={this.state.isView}
            onClose={() => this.setState({ isView: false })}
            style={{ padding: 40 }}
            classes={{
              paper: "planner-drawer padding15 width25",
            }}
          >
            <DrawerHeader
              header="Details"
              isbackarrow={false}
              closeDrawer={() =>
                this.setState({
                  isView: false,
                })
              }
            />
            <div>
              <p className="extra-small-dark-secondary">Report Name</p>
              <p className="small-dark margin-bottom-8">
                {selectedReport && selectedReport.reportname}
              </p>

              <p className="extra-small-dark-secondary">Schedule Type</p>
              <p className="small-dark margin-bottom-8">
                {selectedReport && selectedReport.frequency
                  ? selectedReport.frequency
                  : "-"}
              </p>
              <p className="extra-small-dark-secondary">Schedule Time</p>
              <p className="small-dark margin-bottom-8">
                {selectedReport && selectedReport.scheduledtime
                  ? selectedReport.scheduledtime
                  : "-"}
              </p>
              <p className="extra-small-dark-secondary">Added Date</p>
              <p className="small-dark margin-bottom-8">
                {selectedReport && selectedReport.updateddate
                  ? getFormattedDate(
                      selectedReport.updateddate,
                      this.state.ShortDateFormat,
                    )
                  : "-"}
              </p>
              <p className="extra-small-dark-secondary">Added By</p>
              <p className="small-dark margin-bottom-8">
                {selectedReport && selectedReport.addedby
                  ? selectedReport.addedby
                  : "-"}
              </p>
              <p className="extra-small-dark-secondary">Request Start Date</p>
              <p className="small-dark margin-bottom-8">
                {selectedReport && selectedReport.requeststartdate
                  ? selectedReport.requeststartdate
                  : "-"}
              </p>
            </div>
          </Drawer>
        </div>
      </IntlProvider>
    );
  }
}

ScheduledReport.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateSubscriptionInfo: (type, payload) =>
        updateSubscriptionInfo(type, payload),
      RightDrawer: (data) => RightDrawer(data),
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(ScheduledReport)));
